import { render, staticRenderFns } from "./default-switch.vue?vue&type=template&id=1eeeda4d&"
import script from "./default-switch.vue?vue&type=script&lang=js&"
export * from "./default-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports